/*
 * track-product-options.js
 * 纯加法埋点：产品选项"值真变化"时 push product_option_select（measurement_version:2）。
 * 不改任何选择/变体/加购逻辑；只读 DOM + push dataLayer。契约见 docs/tracking-contract-data-track.md。
 *
 * 依实测(GTM Preview 控制台 diag)定稿：
 *  - BCPO radio(images/colors) = 真实用户 change，originalEvent.isTrusted=true，原生+jQuery 都能收到。
 *  - 尺寸(Single Panel Width/Length) = sizeInit 芯片 → jQuery .trigger('change') 打到隐藏 select+text，
 *    原生 addEventListener 收不到，必须 jQuery 绑定；且一次发俩(select+text)，需去重。
 *  - 主题联动/初始化也走 jQuery .trigger('change')（无 originalEvent）→ 用"同组刚有真实用户交互"过滤。
 *  - 标题在 .bcpo-title(带尾冒号，如 "Header Type:")，逐产品不同 → option_type = 标题去冒号转 snake_case。
 */
(function () {
  'use strict';
  if (window.__thProductOptionTrackingBound) return;

  function boot($) {
    if (window.__thProductOptionTrackingBound) return;
    window.__thProductOptionTrackingBound = true;
    window.dataLayer = window.dataLayer || [];

    // 标题 -> option_type：去尾冒号、小写、snake_case
    function toType(title) {
      return (title == null ? '' : String(title))
        .replace(/[:：]\s*$/, '')
        .trim().toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
    }
    function norm(s) { return (s == null ? '' : String(s)).replace(/\s+/g, ' ').trim(); }

    // 选项组容器：BCPO=.selector-wrapper，原生变体=.product-form__controls
    function optionGroup(el) {
      if (!el || !el.closest) return null;
      return el.closest('#bcpo .selector-wrapper') || el.closest('.product-form__controls');
    }
    // 从组里读 option_type
    function groupType(group) {
      var t = group.querySelector('.bcpo-title');
      if (t) return toType(t.textContent);
      var gn = group.querySelector('.product-form__group-name');
      if (gn) return toType(gn.textContent);
      var sl = group.querySelector('.select-label');
      if (sl) return toType((sl.textContent || '').split(/[:：]/)[0]);
      return null;
    }

    // "同组刚有真实用户交互"闸门：给尺寸芯片(jQuery 派发的 change)放行，同时挡联动/初始化
    var armedGroup = null, armedTs = 0;
    function arm(e) {
      var g = optionGroup(e.target);
      if (g) { armedGroup = g; armedTs = Date.now(); }
    }
    document.addEventListener('pointerdown', arm, true);
    document.addEventListener('click', arm, true);
    document.addEventListener('keydown', arm, true);

    $(document).on('change.thTrackOpt', function (e) {
      var el = e.target;
      if (!el) return;
      var isRadio = el.tagName === 'INPUT' && el.type === 'radio';
      var isSelect = el.tagName === 'SELECT';
      if (!isRadio && !isSelect) return;          // 只收 radio + select（尺寸 text 镜像走 select 那次，去重掉）
      if (isRadio && !el.checked) return;          // 被回滚/未选中的不发

      var group = optionGroup(el);
      if (!group) return;

      // 闸门：真实原生用户 change(radio/原生变体) 直接放行；jQuery 派发的(尺寸芯片)需同组刚有用户交互
      var oe = e.originalEvent;
      var trusted = !!(oe && oe.isTrusted === true);
      var armed = (armedGroup === group) && (Date.now() - armedTs < 3000);
      if (!trusted && !armed) return;              // 挡掉联动/初始化的 .trigger('change')

      var type = groupType(group);
      if (!type) return;                           // 无标题的组跳过
      var value = norm(el.value);
      if (!value) return;                          // 空值不发

      // 按控件组去重（尺寸 select+text 同值只发一次）
      var sig = type + '=' + value;
      if (group.__thLastSig === sig) return;
      group.__thLastSig = sig;

      window.dataLayer.push({
        event: 'track_event',
        tracking: {
          event_name: 'product_option_select',
          interaction: 'change',
          measurement_version: 2,
          params: { option_type: type, option_value: value }
        }
      });
    });
  }

  // 依赖主题的 jQuery（用来捕获尺寸芯片的 jQuery 派发 change）；等它就绪
  if (window.jQuery) { boot(window.jQuery); return; }
  var tries = 0;
  var iv = setInterval(function () {
    if (window.jQuery) { clearInterval(iv); boot(window.jQuery); }
    else if (++tries > 50) { clearInterval(iv); } // ~5s 仍无 jQuery 则放弃（不影响页面）
  }, 100);
})();
